import * as React from 'react';
import classNames from 'classnames';
import styles from './ViewBackground.scss';
import equal from 'fast-deep-equal/react';
import { useSelector } from 'react-redux';
import { State } from '~/Reducers';
import { isEmptyObject } from '~/utils/utils';
import { settings } from '~/utils/settings';
import { ICurrentPage } from '~/Actions/ActionAppType';
import VideoBackground from '~/components/VideoBackground/VideoBackground';
import { useAvailableSound } from '~/hooks/useAvailableSound';

interface IStateSelector {
    viewBackground: string;
    bundles: IBundleList;
    selectedRandomBundles: AccountSelectedRandomBundles;
    isTrusted: boolean;
    soundStatus: SoundStatus;
    port: IPort;
    currentPage: ICurrentPage;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        viewBackground: state.ReducerApp.viewBackground,
        selectedRandomBundles: state.ReducerAccount.selectedRandomBundles,
        isTrusted: state.ReducerApp.isTrusted,
        soundStatus: state.ReducerApp.soundStatus,
        port: state.ReducerApp.port,
        bundles: state.ReducerApp.bundles,
        currentPage: state.ReducerApp.currentPage,
    };
};

interface IVideoViewBackground {
    isBlur: boolean;
    bundle: IBundle;
    category: ICategory;
    children?: React.ReactChild;
}

const VideoViewBackground = ({ isBlur, bundle, category }: IVideoViewBackground) => {
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    let currentBundle = bundle;
    let bundleVideoBackground = bundle?.videoBackground;
    if (isEmptyObject(bundleVideoBackground) && bundle?.parentBundleId) {
        currentBundle = state.bundles[bundle.parentBundleId];
        bundleVideoBackground = currentBundle.videoBackground;
    }
    const categoryVideoBackground = category?.videoBackground;
    const [isBlurView, setBlur] = React.useState(false);
    const isAvailableSoundEffect = useAvailableSound(category, currentBundle);
    let muted = !isAvailableSoundEffect;
    if (!state.isTrusted) {
        muted = true;
    }

    React.useEffect(() => {
        setBlur(isBlur);
    }, [isBlur]);

    if (state.port?.isVisible) {
        return null;
    }

    const backgroundColor = bundle?.backgroundColor || category?.backgroundColor;
    const style = !!backgroundColor ? ({ '--bundle-video-background-color': backgroundColor } as React.CSSProperties) : {};

    const classesWrapper = classNames(styles.videoBackgroundWrapper, { [styles.blur]: isBlurView });

    return (
        <div className={classesWrapper} style={style}>
            <VideoBackground
                muted={muted}
                poster={state.viewBackground}
                video={isEmptyObject(bundleVideoBackground) ? categoryVideoBackground : bundleVideoBackground}
                className={classNames(state.currentPage?.name, styles[state.currentPage?.name], styles[settings.realm], {
                    [styles.videoBackground]: !!backgroundColor,
                })}
                withMask={!!backgroundColor}
            >
                {!!backgroundColor && <div className={styles.videoBackgroundMask}></div>}
            </VideoBackground>
        </div>
    );
};

export default React.memo(VideoViewBackground);
